/* src/app/modules/search/components/doc-view/components/email-view/email-view.component.scss */
.email-view-container {
  max-height: calc(100vh - 6rem);
  overflow: auto;
  margin: 0;
  padding: 0;
  padding-right: 0.5rem;
}
.email-view-container .email-view-header {
  display: flex;
  justify-content: space-between;
  margin: 1px 0.1rem;
  padding: 0 1rem;
  border-radius: 0.5rem;
}
.email-view-container .email-view-header h3 {
  flex: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 35rem;
  white-space: nowrap;
  margin: 0.95rem;
}
.email-view-container .email-view-body {
  margin: 1px 0.1rem;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-top: 0.5rem;
}
.email-view-container .email-view-body .loader_container {
  height: calc(100vh - 28rem);
}
.email-view-container .no-content-found {
  height: calc(100vh - 36rem);
}
.email-view-container-new-tab {
  width: calc(100% - 1rem) !important;
  max-height: 100% !important;
  margin: 0.5rem !important;
}
.paginator {
  display: flex;
  justify-content: center;
  border: solid 1px #e0e0e0;
  margin: 0.5rem;
  border-radius: 0.5rem;
  height: 3rem;
  align-items: center;
}
.extracted-entity-viewer {
  overflow: auto;
  border-radius: 0.5rem;
  padding: 1rem;
  margin: 0.4rem 0.25rem;
  margin-bottom: 1px;
  margin-right: 1px;
}
.email-view-body-container ::ng-deep p-splitter {
  width: 100%;
}
.email-view-body-container ::ng-deep .p-splitter-horizontal {
  width: 100%;
}
.email-view-body-container ::ng-deep .p-splitter-panel:first-child {
  width: 100% !important;
  min-width: 55% !important;
  transition: min-width 0.2s cubic-bezier(0.4, 0, 0.2, 1), overflow 0.2s ease-in-out;
}
.email-view-body-container ::ng-deep .p-splitter-panel:last-child {
  min-width: 25%;
  transition: min-width 0.2s cubic-bezier(0.4, 0, 0.2, 1), overflow 0.2s ease-in-out;
}
.email-view-body-container-entity ::ng-deep .p-splitter-gutter {
  display: none !important;
}
.email-view-body-container-entity ::ng-deep .p-splitter-panel:first-child {
  flex-basis: 100% !important;
}
.email-view-body-container-entity ::ng-deep .p-splitter-panel:last-child {
  flex-basis: 0 !important;
  width: 0 !important;
  min-width: 0 !important;
}
/*# sourceMappingURL=email-view.component.css.map */
